export const dateSanitizer = (value) => { 
    if (value) {
      let date = value.substring(0, 10);
      let dateSplit = date.split('-');
      return dateSplit[2] + "-" + dateSplit[1] + "-" + dateSplit[0];
    } else {
      return '';
    }
  }